/**
 * getUserBadgePlacements.js
 * Written by: Alex Kasemir
 */
import request from '../../../request/actions';

export const getUserBadgePlacementsStart = () => ({
  type: `GET_BADGE_PLACEMENTS_START`,
});

export const getUserBadgePlacementsSuccess = (user, data) => ({
  type: `GET_BADGE_PLACEMENTS_SUCCESS`,
  user,
  data,
});

export const getUserBadgePlacementsFailure = (user, error) => ({
  type: `GET_BADGE_PLACEMENTS_FAILURE`,
  user,
  error,
});

/**
 * Description of the getUserBadgePlacements action
 */
export const getUserBadgePlacements = (userId = null) => {
  return async (dispatch) => {
    dispatch(getUserBadgePlacementsStart());
    try {
      const response = await dispatch(request(`/users/${userId}/badges?placements=t`, `GET`));
      dispatch(getUserBadgePlacementsSuccess(userId, response.data));
    } catch (e) {
      dispatch(getUserBadgePlacementsFailure(userId, e));
    }
  };
};

export default getUserBadgePlacements;
